export default "__VITE_ASSET__z$k3q18o__"